import script from "./document-total.vue?vue&type=script&setup=true&lang=js"
export * from "./document-total.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__